<template>
  <div>
    <div v-if="domeReady" class="KycInfo">
      <div class="KycInfo__container">
        <div class="KycInfo__title">{{ title }}</div>
        <div class="KycInfo__description" v-html="nl2br(description)"></div>

        <!-- Main Visual -->
        <KYCMainVisualContent />

        <div class="KycInfo__informatino-text">
          <div
            class="KycInfo__informatino-text-title"
            v-html="nl2br(infotmation.title)"
          ></div>
          <div
            class="KycInfo__informatino-text-description"
            v-html="nl2br(infotmation.description)"
          ></div>
        </div>
        <!-- Main Information -->
        <div
          ref="KYCMainVisualInformation"
          data-aos="zoom-in"
          data-aos-duration="1000"
        >
          <KYCMainVisualInformation v-if="classFlag" />
        </div>

        <!-- Main Step Slide -->
        <div data-aos="zoom-in" data-aos-duration="1000">
          <KYCMainVisualStep />
        </div>
      </div>

      <!-- App download banner -->
      <KYCAppBanner />

      <!-- FQA -->
      <KYCFAQ />
    </div>
    <div v-else style="height: 2000px; background: #050a28"></div>
  </div>
</template>
<script>
import KYCMainVisualContent from "./KYCMainVisualContent.vue";
import KYCMainVisualInformation from "./KYCMainVisualInformation.vue";
import KYCMainVisualStep from "./KYCMainVisualStep.vue";
import KYCAppBanner from "./KYCAppBanner.vue";
import KYCFAQ from "./KYCFAQ.vue";

import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();

export default {
  name: "KycInfo",
  components: {
    KYCMainVisualContent,
    KYCMainVisualInformation,
    KYCMainVisualStep,
    KYCAppBanner,
    KYCFAQ,
  },
  data() {
    return {
      title: "고객확인제도란?",
      description:
        "2021/12/01 부터 고객확인제도를 본격 시행합니다.\n고객확인 인증 절차를 완료한 후 모든 거래 서비스 이용이 가능합니다.",
      infotmation: {
        title: "건전하고 투명한 가상자산 거래를\n 위한 고객확인제도(CDD)",
        description:
          "「특정 금융거래정보의 보고 및 이용 등에 관한 법률(특정금융정보법)」 제 5조의 2에 의한 법률적 의무사항으로 금융기관 등이 제공하는 금융거래 및 서비스가 자금세탁 등의 불법행위에 이용되지 않도록 고객의 신원사항 (실지명의, 직업, 주소, 연락처 등), 거래목적 및 자금출처, 실제 소유자 등을 확인하는 절차입니다. ",
        sub_desc:
          "플라이빗은 2021년 내\n 고객확인제도 의무화를 시행할 예정입니다.",
      },
      classFlag: false,
      domeReady: false,
    };
  },
  mounted() {
    console.log(window.innerHeight);
    if (window.innerHeight > 812) {
      this.classFlag = true;
    }

    document.addEventListener("scroll", () => {
      const ElementClassLength =
        this.$refs["KYCMainVisualInformation"].classList.length;

      ElementClassLength === 2
        ? (this.classFlag = true)
        : (this.classFlag = false);
    });

    setTimeout(() => {
      this.domeReady = true;
    }, 100);
  },
  methods: {
    nl2br(str) {
      return str.replace(/\n/g, "<br />");
    },
  },
};
</script>
<style lang="scss" scoped>
.KycInfo {
  &__container {
    padding: 80px 0;
    background: #050a28;
  }

  &__title {
    font-size: 24px;
    text-align: center;
    color: #fff;
    font-weight: 500;
  }

  &__description {
    font-size: 14px;
    text-align: center;
    color: #bec3cd;
    font-weight: 300;
    margin-top: 12px;
    line-height: 1.5;
    padding: 0 15px;
    word-break: keep-all;
  }

  &__informatino-text {
    padding: 0 20px 40px 20px;
    margin-top: 80px;

    &-title {
      font-size: 24px;
      color: #fff;
      font-weight: 500;
      text-align: center;
    }

    &-description {
      font-size: 14px;
      color: #bec3cd;
      font-weight: 300;
      margin-top: 12px;
      word-break: keep-all;
      text-align: center;
    }
  }
}
</style>
